<div class="g-dialog-box">
    <div class="g-header-row">
        <p class="g-header">Create Spot Auction</p>
        <img class="g-close-icon" src="../../../../../assets/icons/close-x.svg" (click)="closeDialog()">
    </div>
    <div class="content">
        <p class="message">
            {{message}}
        </p>
    </div>
    <div class="actions">
        <button class="btn secondary medium" (click)="closeDialog()">Cancel </button>
        <button class="btn primary medium" (click)="closeDialogWithResult()">Confirm</button>
    </div>
</div>